import { useState } from "react"

const EXPIRY_DATE = new Date("2026-06-01")
const DISMISSED_KEY = "migration_banner_dismissed"

function shouldShow(): boolean {
    if (typeof window === "undefined") return false
    if (new Date() >= EXPIRY_DATE) return false
    return localStorage.getItem(DISMISSED_KEY) !== "1"
}

export default function MigrationBanner() {
    const [visible, setVisible] = useState(shouldShow)

    if (!visible) return null

    return (
        <div style={{
            background: "var(--theme-banner-color)",
            color: "white",
            textAlign: "center",
            padding: "10px 16px",
            fontSize: "0.9rem",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "8px"
        }}>
            <span>ValTerrain.com is now <strong>HomeIndex.ie</strong>. Same platform. Same data. Just a better name.</span>
            <button
                onClick={() => {
                    localStorage.setItem(DISMISSED_KEY, "1")
                    setVisible(false)
                }}
                style={{
                    background: "none",
                    border: "none",
                    cursor: "pointer",
                    fontSize: "1rem",
                    padding: "0 4px",
                    color: "white"
                }}
                aria-label="Dismiss"
            >
                &times;
            </button>
        </div>
    )
}
